export default __webpack_public_path__ + "static/media/Vasilis_Zotikas_CV_2021.9215878b.pdf";